import { SET_COMPANY_DATA } from "./action.types";

export const setCompanies = (payload) => ({ type: SET_COMPANY_DATA, payload });
